/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Client_Id_HintInputs */

const cs_sreality_client_id_hint = /** @type {(inputs: Sreality_Client_Id_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Číselné RK id z importu Sreality (admin.sreality.cz). Jedno na kancelář.`)
};

const en_sreality_client_id_hint = /** @type {(inputs: Sreality_Client_Id_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numeric RK id from Sreality import (admin.sreality.cz). One per office.`)
};

/**
* | output |
* | --- |
* | "Numeric RK id from Sreality import (admin.sreality.cz). One per office." |
*
* @param {Sreality_Client_Id_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_client_id_hint = /** @type {((inputs?: Sreality_Client_Id_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Client_Id_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_client_id_hint(inputs)
	return cs_sreality_client_id_hint(inputs)
});